module.exports = __webpack_public_path__ + "static/media/refresh.b05186f8.svg";